import { render, staticRenderFns } from "./CourseReports.vue?vue&type=template&id=ba0dc0e4&scoped=true"
import script from "./CourseReports.vue?vue&type=script&lang=js"
export * from "./CourseReports.vue?vue&type=script&lang=js"
import style0 from "./CourseReports.vue?vue&type=style&index=0&id=ba0dc0e4&prod&scoped=true&lang=css"
import style1 from "./CourseReports.vue?vue&type=style&index=1&id=ba0dc0e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0dc0e4",
  null
  
)

export default component.exports